import axios from 'axios';

class FiLoanOriginationClient {
  static getSigningLink(id, customerId) {
    return axios.get(`/api/v1/signing/${id}/link${customerId ? `?customerId=${customerId}` : ''}`);
  }

  static signicatCallback(id, role, status) {
    return axios.post(`/api/v1/signing/${id}/signicat/callback?role=${role}&status=${status}`, {});
  }

  static redirect(url) {
    window.location.href = url;
  }
}

export default FiLoanOriginationClient;
